import { Stack, Typography } from "@mui/material";
import MentalWellbeingChart, { MentalWellbeingChartDataPoint } from ".";

const sampleDepressionData: MentalWellbeingChartDataPoint[] = [
  { date: "20/01", fullDate: "20.01.2025", score: 2 },
  { date: "02/04", fullDate: "02.04.2025", score: 1 },
  { date: "04/04", fullDate: "04.04.2025", score: 0 },
  { date: "12/05", fullDate: "12.05.2025", score: 0 },
  { date: "20/08", fullDate: "20.08.2025", score: 0, isSelected: true },
];

const sampleAnxietyData: MentalWellbeingChartDataPoint[] = [
  { date: "20/01", fullDate: "20.01.2025", score: 1 },
  { date: "02/04", fullDate: "02.04.2025", score: 2 },
  { date: "04/04", fullDate: "04.04.2025", score: 0 },
  { date: "12/05", fullDate: "12.05.2025", score: 1 },
  { date: "20/08", fullDate: "20.08.2025", score: 0, isSelected: true },
];

const highDepressionData: MentalWellbeingChartDataPoint[] = [
  { date: "20/01", fullDate: "20.01.2025", score: 4 },
  { date: "20/08", fullDate: "20.08.2025", score: 5, isSelected: true },
];

const highAnxietyData: MentalWellbeingChartDataPoint[] = [
  { date: "20/01", fullDate: "20.01.2025", score: 3 },
  { date: "20/08", fullDate: "20.08.2025", score: 4, isSelected: true },
];

export default function MentalWellbeingChartExamples() {
  return (
    <Stack gap={3} width="100%">
      <Typography variant="h6" fontWeight={600}>
        Mixed scores (Depression / Anxiety tabs)
      </Typography>
      <MentalWellbeingChart
        depressionChartData={sampleDepressionData}
        anxietyChartData={sampleAnxietyData}
      />

      <Typography variant="h6" fontWeight={600}>
        High risk scores (3–6)
      </Typography>
      <MentalWellbeingChart
        depressionChartData={highDepressionData}
        anxietyChartData={highAnxietyData}
      />
    </Stack>
  );
}
